import React from "react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const SingleMovie = () => {
  const API_URL = `https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}`;
  const [movie, setMovie] = useState({});
  let params = useParams();
  const fetchSingleMovie = async () => {
    const res = await fetch(`${API_URL}&i=${params.id}`);
    const data = await res.json();
    setMovie(data);
    // console.log(data);
  };
  useEffect(() => {
    fetchSingleMovie();
  }, []);

  return (
    <section className="main-container">
      <article className="movie-card">
        <img src={movie.Poster} alt="" />
        <div className="content">
          <h3>{movie.Title}</h3>
          <p>{movie.Released}</p>
          <p>{movie.Genre}</p>
          <p>{movie.imdbRating} / 10</p>
          <p>{movie.Actors}</p>
          <Link to="/" className="back-btn">
            Go back
          </Link>
        </div>
      </article>
    </section>
  );
};

export default SingleMovie;
